import React from "react";
import { MessageCircle, ExternalLink, RefreshCw } from "lucide-react";
import { URL_SISTEMA, buildWhatsappUrl } from "../data/conteudoPorNicho";

export default function Footer({ conteudo, onTrocarNicho }) {
  const whatsappHref = buildWhatsappUrl(conteudo.hero.mensagemWhatsapp);

  return (
    <footer
      className="border-t border-white/5 py-12 px-4 md:px-6 bg-[#080808]"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-5 gap-8">
          <div className="md:col-span-2 flex flex-col gap-4">
            <img
              src="/evolzap-logo-horizontal.png"
              alt="Evolzap"
              className="h-7 self-start"
            />
            <p className="text-zinc-400 text-sm leading-relaxed max-w-md">
              Sistema de atendimento e gestão multichannel pra pequenos e
              médios negócios. Multi WhatsApp, automação inteligente e tudo num
              lugar só.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Produto</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="/#recursos"
                  className="text-zinc-400 hover:text-white transition-colors"
                >
                  Recursos
                </a>
              </li>
              <li>
                <a
                  href="/#planos"
                  className="text-zinc-400 hover:text-white transition-colors"
                >
                  Planos
                </a>
              </li>
              <li>
                <a
                  href="/#faq"
                  className="text-zinc-400 hover:text-white transition-colors"
                >
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Contato</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={whatsappHref}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-zinc-400 hover:text-white transition-colors"
                >
                  <MessageCircle className="w-4 h-4" />
                  WhatsApp
                </a>
              </li>
              <li>
                <a
                  href={URL_SISTEMA}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-zinc-400 hover:text-white transition-colors"
                >
                  <ExternalLink className="w-4 h-4" />
                  Acessar sistema
                </a>
              </li>
            </ul>
          </div>

          <div data-testid="footer-coluna-legal">
            <h4 className="text-white font-semibold text-sm mb-4">Legal</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="https://app.evolzap.com/legal/privacidade.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-zinc-400 hover:text-white transition-colors"
                >
                  Política de Privacidade
                </a>
              </li>
              <li>
                <a
                  href="https://app.evolzap.com/legal/termos.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-zinc-400 hover:text-white transition-colors"
                >
                  Termos de Serviço
                </a>
              </li>
              <li>
                <a
                  href="https://app.evolzap.com/legal/exclusao-de-dados.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-zinc-400 hover:text-white transition-colors"
                >
                  Exclusão de Dados
                </a>
              </li>
              <li>
                <a
                  href="/privacidade-google"
                  className="text-zinc-400 hover:text-white transition-colors"
                >
                  Login com Google
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 mt-10 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-zinc-500 text-sm">
            © 2026 Evolzap Tecnologia. Todos os direitos reservados.
          </p>
          <button
            onClick={onTrocarNicho}
            data-testid="footer-trocar-nicho"
            className="inline-flex items-center gap-1.5 text-xs text-zinc-500 hover:text-zinc-300 px-3 py-1.5 rounded-lg hover:bg-white/5 transition-colors"
          >
            <RefreshCw className="w-3.5 h-3.5" />
            Trocar nicho atual ({conteudo.nome})
          </button>
        </div>
      </div>
    </footer>
  );
}
